import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@app/models/_base/apiResponse.model';
import { ChecklistResponse } from '@app/models/shortlist/checklist.model';
import { Observable } from 'rxjs';

import { AppConfig } from '../app.config';
import { CurrentQuestionnaireService } from './current-questionnaire.service';

@Injectable()
export class ChecklistService {
  private checklistCache;
  private checklistObservable: Observable<any>;

  constructor(
    private http: HttpClient,
    private currentQuestionnaire: CurrentQuestionnaireService
  ) {}

  checkCourseChecklistItem(id: string | number): Observable<ApiResponse> {
    let url =
      AppConfig.ApiUrl + `research/${this.currentQuestionnaire.get()}/checklist/item/${id}/check`;
    return this.http.put<ApiResponse>(url, null);
  }

  uncheckCourseChecklistItem(id: string | number): Observable<ApiResponse> {
    let url =
      AppConfig.ApiUrl + `research/${this.currentQuestionnaire.get()}/checklist/item/${id}/check`;
    return this.http.delete<ApiResponse>(url);
  }

  getChecklists(): Observable<ChecklistResponse> {
    if (this.checklistObservable) {
      return this.checklistObservable;
    } else {
      const url = AppConfig.ApiUrl + `research/${this.currentQuestionnaire.get()}/checklist`;
      this.checklistObservable = this.http
        .get<ChecklistResponse>(url)
        .map(data => {
          this.checklistObservable = null;
          this.checklistCache = data as ChecklistResponse;
          return this.checklistCache;
        })
        .share();
      return this.checklistObservable;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/checklist.service.ts